// extracted by mini-css-extract-plugin
module.exports = {"landing":"styles_landing__xKCdG","preferenciaLabel":"styles_preferenciaLabel__2ysNI","errorMessage":"styles_errorMessage__3jqcm","descricao":"styles_descricao__sqk7L"};